import React, { useEffect, useRef, useState } from 'react'
import './distribute-page.styles.scss';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faFlask, faGift } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import RewardsForm from '../create-elements/blocks/rewards-form.component';
import { UseCloudGameTransactions } from '@/utils/firebase.utils';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import PlayerSelector from '@/components/SHARED/player-selector/player-selector.component';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import DistributeReviewItem from './distribute-review-item.component';
import useAnalytics from '@/utils/useAnalytics';

const DistributePage = ({
  gameData,
  gameElements,
  playerList,
  teamMembers
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const membership = useSelector(state => state.userData.membership);
  const [formData, setFormData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [playersToDisplay, setPlayersToDisplay] = useState(null);
  const [chosenPlayers, setChosenPlayers] = useState([]); // playerIds
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [review, setReview] = useState(false);
  const [showEditBoxList, setShowEditBoxList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [distributionObj, setDistributionObj] = useState({});
  const [loaderText, setLoaderText] = useState(null);
  const { trackEvent, trackException } = useAnalytics();
  const navigate = useNavigate();
  const location = useLocation();
  const dataRef = useRef({ 'type': 'players' });
  const chosenPlayerRef = useRef();
  const approveRef = useRef();
  const indDistRef = useRef();
  const teamRef = useRef();

  const [searchParams] = useSearchParams();
  const [selectedPlayerPath, setSelectedPlayerPath] = useState(searchParams.get("p"));

  useEffect(() => {
    chosenPlayerRef.current = []
    setFormData(dataRef.current);
  }, [])

  useEffect(() => {
    if (!playerList || !selectedPlayerPath) { return; }
    const player = Object.values(playerList)
      .find(p => p.path === selectedPlayerPath);
    if (!player) { return; }
    togglePlayer(player, 'select');
    const selectorBox = document.querySelector(`.player-selector-box`);
    const playerElement = document.getElementById(player.playerId);
    if (playerElement) {
      playerElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, [playerList, selectedPlayerPath])

  useEffect(() => {
    if (!gameData) { return; }
    // getGamePlayers();
  }, [gameData])

  useEffect(() => {
    if (!playerList) { return; }
    setPlayersToDisplay(Object.values(playerList).filter(p => !p.team));
    setTeamList(Object.values(playerList).filter(p => p.team));
  }, [playerList])

  // useEffect(() => {
  //     chosenPlayerRef.current = []
  //     setChosenPlayers(chosenPlayerRef.current);
  // }, [formData.type])

  function cancel() {
    setShowEditBoxList([]);
    if (review) {
      goBack();
    } else {
      navigate(`${
        location.pathname.includes('/preview/manager/') 
        ? '/preview/manager' 
        : '/manage'
      }/${gameData.path}`);
    }
  }

  // either adds or removes a player from the chosen players list
  function togglePlayer(player, choice) {
    let newList = chosenPlayerRef.current ? [...chosenPlayerRef.current] : [];
    if (choice === 'select') {
      if (!newList.includes(player.playerId)) {
        newList.push(player.playerId)
      }
      chosenPlayerRef.current = [...newList];
      setChosenPlayers(chosenPlayerRef.current);
      setDefaultDistribution();
      return;
    }
    if (choice === 'deselect') {
      if (newList.includes(player.playerId)) {
        newList.splice(newList.indexOf(player.playerId), 1);
      }
      chosenPlayerRef.current = [...newList];
      setChosenPlayers(chosenPlayerRef.current);
      return;
    }

    if (newList.includes(player.playerId)) {
      newList.splice(newList.indexOf(player.playerId), 1);
    } else {
      newList.push(player.playerId);
    }
    chosenPlayerRef.current = [...newList];
    setChosenPlayers(chosenPlayerRef.current);
    setDefaultDistribution();
  }

  function saveData(key, value) {
    dataRef.current = { ...dataRef.current, ...{ [key]: value } }
    setFormData(dataRef.current);
    setDefaultDistribution();
  }


  function cancelDistribution() {
    setConfirmMessage('Are you sure you want to cancel? Any progress will be lost.');
    approveRef.current = () => {
      dataRef.current = {}
      setFormData(dataRef.current);
      navigate(`/manage/${gameData.path}`);
    }
  }

  function setDefaultDistribution() {
    let tempData = { ...dataRef.current };
    // if (!tempData.title) {
    //     setAlertMessage('Please give this reward a title so your players know why they received it.');
    //     return;
    // }

    let obj = {};
    for (let p of chosenPlayerRef.current) {
      obj[p] = { ...tempData };
      obj[p].playerId = p;
      if (obj[p].title) {
        delete obj[p].title;
      }
      if (obj[p].info) {
        delete obj[p].info;
      }
    }
    indDistRef.current = { ...obj };
    setDistributionObj(indDistRef.current);
    // setReview(true);
  }

  function saveIndDistribution(playerId, newDistribution) {
    const newTempDist = { ...distributionObj, ...{ [playerId]: newDistribution } };
    indDistRef.current = { ...newTempDist };
    setDistributionObj(indDistRef.current);
  }

  function goToReview() {
    let tempData = { ...dataRef.current };
    console.log(tempData);
    if (!tempData.title) {
      setAlertMessage('Please give this reward a title so your players know why they are receiving it.');
      return;
    }
    const earnedKeys = Object.keys(tempData).filter(k => k.includes('opt_earned'));
    if (earnedKeys.length === 0) {
      setAlertMessage('Please choose a default reward before moving on.');
      return;
    }
    setReview(true);
  }

  function goBack() {
    // indDistRef.current = {};
    // setDistributionObj(indDistRef.current);
    // setShowEditBoxList([]);
    // setConfirmMessage('Are you sure you want to go back? Any individual changes will be lost.');
    // approveRef.current = () => {
    setReview(false);
    //     approveRef.current = null;
    // }
  }

  function toggleEditBox(id) {
    let list = [...showEditBoxList];
    if (showEditBoxList.includes(id)) {
      list.splice(list.indexOf(id), 1);
    } else {
      list.push(id);
    }
    setShowEditBoxList([...list]);
  }

  function distributeRewards() {
    if (location.pathname.includes('/preview/manager/')) {
        setAlertMessage('Sorry! Data cannot be saved in Preview Mode.');
        return;
    }
    setConfirmMessage('Are you sure you are ready to distribute these rewards as they appear on this page? This action cannot be undone.');
    approveRef.current = () => {
      proceedWithDistribution();
    }

    async function proceedWithDistribution() {
      setLoading(true);
      let tempData = { ...formData };
      tempData.ts = new Date().getTime();
      const obj = {
        'appId': userProfile.appId,
        'gameId': gameData.gameId,
        'title': tempData.title,
        'info': tempData.info,
        'recipientArr': Object.values(indDistRef.current),
      };
      const res = await UseCloudGameTransactions(
        'distributeRewardsBulk',
        obj
      );
      console.log(res);
      setLoading(false);
      if (res.error) {
        setAlertMessage('Something went wrong. Error: ' + res.error);
        trackException(`Distribute Rewards Error: ${res.error}`);
        return;
      }
      setAlertMessage('Rewards distributed successfully!');
      trackEvent(
        'rewards_distributed',
        'Game Manager',
        `${Object.values(indDistRef.current).length} players received rewards for game ${gameData.gameId}.`,
        null,
        membership
      );
      clearDistribution();
    }
  }



  function clearDistribution() {
    dataRef.current = {};
    setFormData(dataRef.current);
    chosenPlayerRef.current = [];
    setChosenPlayers(chosenPlayerRef.current);
    setPlayersToDisplay(chosenPlayerRef.current);
    setReview(false);
    setLoading(false);
    setShowEditBoxList([]);
  }

  return (
    <div className={`distribute-page-container ${screenSize}`}>
      <div className='distribute-content g-card'>
        <BackButton cancel={cancel} />
        <div className="g-space-1"></div>
        <div className='card-title'>Distribute Rewards</div>
        {
          (!review) &&
          <>
            <div className='g-space-1'></div>
            <div className='reward-info-container'>
              <div className='reward-info g-list-item grey-background'>
                <h3>Reward Information</h3>
                <hr />
                <div className='field'>
                  <label>Reward Title</label>
                  <input type='text' value={formData.title ?? ''} onChange={(e) => saveData('title', e.target.value)} />
                </div>
                <div className='g-space-1'></div>
                <div className='field'>
                  <label>Additional Information (optional)</label>
                  <input type='text' value={formData.info ?? ''} onChange={(e) => saveData('info', e.target.value)} />
                </div>
                <div className="g-space-1"></div>
              </div>
              <div className="g-space-2"></div>
              <div className='how-to-distribute-row g-list-item grey-background'>
                <h3>How do you want to distribute these rewards?</h3>
                <hr />
                <div className='button-row-1'>
                  <button
                    className={`g-button ${formData.type === 'players'
                        ? 'active'
                        : ''
                      } ${screenSize === 'mobile' ? 'med-btn' : ''}`}
                    onClick={() => saveData('type', 'players')}
                  >
                    Distribute to Players
                  </button>
                  <button
                    className={`g-button ${formData.type === 'teamTotals'
                        ? 'active'
                        : ''
                      } ${Object.values(teamList).length === 0
                        ? 'disabled'
                        : ''
                      }  ${screenSize === 'mobile'
                        ? 'med-btn'
                        : ''
                      }`}
                    onClick={() => saveData('type', 'teamTotals')}
                  >
                    Distribute to Team Totals
                  </button>
                </div>
                <div className='g-space-1'></div>
              </div>
            </div>
            <div className='g-space-2'></div>
          </>
        }
        {
          (!review && formData.type === 'players') &&
          <>
            <div className='player-select g-list-item grey-background'>
              <h3>Select Players</h3>
              <hr />
              <PlayerSelector
                playerList={playerList}
                teamMembers={teamMembers}
                gameElements={gameElements}
                chosenPlayers={chosenPlayers}
                togglePlayer={togglePlayer}
                type='players'
                displayArr={['info']}
              />
              <div className='g-space-1'></div>
            </div>
            <div className="g-space-2"></div>
          </>
        }
        {
          (!review && formData.type === 'teamTotals') &&
          <>
            <div className='player-select g-list-item grey-background'>
              <h3>Select Teams</h3>
              <hr />
              <PlayerSelector
                playerList={playerList}
                gameElements={gameElements}
                chosenPlayers={chosenPlayers}
                togglePlayer={togglePlayer}
                type='teams'
              />
              <div className='g-space-1'></div>
            </div>
            <div className="g-space-2"></div>
          </>
        }
        {
          (!review && formData.type) &&
          <div>
            <div className={`earnings-form g-list-item grey-background ${chosenPlayers.length === 0 ? 'disabled' : ''}`}>
              <h3>Set Default Rewards</h3>
              <hr />
              <RewardsForm
                type='distribution'
                formData={formData}
                saveData={saveData}
                gameElements={gameElements}
                disabled={disabled}
                gameData={gameData}
                teams={formData.type === 'teamTotals'}
              />
            </div>
            <div className="g-space-1"></div>
            <div className='buttons'>
              <button
                className={`g-button ${screenSize === 'mobile'
                    ? 'med-btn'
                    : ''
                  }`}
                onClick={() => cancelDistribution()}>
                Cancel
              </button>
              <button
                className={`g-button primary ${screenSize === 'mobile'
                    ? 'med-btn'
                    : ''
                  }`}
                onClick={() => goToReview()}>
                Review Distribution
              </button>
            </div>
          </div>
        }
        {
          (
            review &&
            chosenPlayers.length > 0 &&
            Object.values(distributionObj).length > 0
          ) &&
          <>
            <div className='review-table'>
              <hr />
              <p>Reward Title: <b>{formData.title}</b></p>
              {
                (formData.info) &&
                <h4>Additional Info: {formData.info}</h4>
              }
              <div className='review-list'>
                {
                  (chosenPlayers.length > 0) &&
                  chosenPlayers.sort((a, b) => {
                    const pa = playerList[a];
                    const pb = playerList[b];
                    if ((pa.lName && pb.lName) && pa.lName.toLowerCase() > pb.lName.toLowerCase()) {
                      return 1;
                    } else if ((pa.fName && pb.lName) && pa.fName.toLowerCase() > pb.lName.toLowerCase()) {
                      return 1;
                    } else if ((pa.lName && pb.fName) && pa.lName.toLowerCase() > pb.fName.toLowerCase()) {
                      return 1;
                    } else if ((pa.fName && pb.fName) && pa.fName.toLowerCase() > pb.fName.toLowerCase()) {
                      return 1;
                    } else {
                      return -1;
                    }
                  })
                    .map(p => {
                      const player = {
                        ...playerList[p],
                        ...{ 'distribution': distributionObj[p] }
                      };
                      return (
                        <DistributeReviewItem
                          key={p}
                          playerObj={player}
                          gameElements={gameElements}
                          gameData={gameData}
                          disabled={disabled}
                          saveIndDistribution={saveIndDistribution} />
                      );
                    })
                }
              </div>
              <hr />
              <div className='buttons'>
                <button
                  className='g-button med-btn'
                  onClick={() => cancel()}>
                  Back
                </button>
                <button
                  className={`g-button primary ${screenSize === 'mobile'
                      ? 'med-btn'
                      : ''
                    }`}
                  onClick={() => distributeRewards()}>
                  Distribute Rewards
                </button>
              </div>
            </div>


          </>
        }

      </div>
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(false)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(false)}
        message={alertMessage} />
      <FullPageLoader
        show={loading}
        text={loaderText} />
    </div>
  )
}

export default DistributePage